import { toast } from "react-toastify";
import { DESGUACES_OFFLINE_API } from "../views/MainLayout/components/shared/services/desguaces_offline";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";


const initialDesguacesOffline = []

export const desguacesOfflineReducer = (state = initialDesguacesOffline, action) => {
    switch(action.type){
        case "desguaces-offline/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchDesguacesOffline = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await DESGUACES_OFFLINE_API.get(page, search)
        const data = await response.data;
        dispatch({ type: 'desguaces-offline/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}